// =============================================================================
// GeneralSettingsTab — placeholder for Sprint 4 generic settings
// =============================================================================

import { Card, CardHeader } from '@tkpod/ui';

export function GeneralSettingsTab() {
  return (
    <Card>
      <CardHeader
        title="General"
        description="System-wide feature flags and maintenance controls."
      />
      <div className="mt-4 flex items-center justify-center py-16 text-sm text-text-tertiary">
        General settings will be available in Sprint 4.
      </div>
    </Card>
  );
}
